module.exports = __webpack_public_path__ + "img/_dsc8162.6f4de363.jpg";